"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_1 = require("@vidazoo/ui");
var moment = require("moment");
var selfTheme = require("./theme.scss");
var _ = require("lodash");
var lib_1 = require("../../../../lib");
var Row = /** @class */ (function (_super) {
    tslib_1.__extends(Row, _super);
    function Row(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.toggleInfo = function () {
            var _a = _this.props, onShowInfo = _a.onShowInfo, item = _a.item;
            if (item.name || item.url) {
                onShowInfo(item);
            }
        };
        _this.onAdServerTester = function (e) {
            var _a = _this.props, item = _a.item, onGenerateLink = _a.onGenerateLink;
            e.stopPropagation();
            e.preventDefault();
            onGenerateLink(item.request, item.campaign);
        };
        _this.onUrlCopyClick = function (e) {
            var item = _this.props.item;
            e.stopPropagation();
            e.preventDefault();
            lib_1.MemoryClipboard.copy(item.url);
        };
        _this.onCurlCopyClick = function (e) {
            var item = _this.props.item;
            e.stopPropagation();
            e.preventDefault();
            lib_1.MemoryClipboard.copy(item.curl);
        };
        return _this;
    }
    Row.prototype.render = function () {
        var _this = this;
        var _a = this.props, item = _a.item, index = _a.index, columnsWidth = _a.columnsWidth, freezeColumnIndex = _a.freezeColumnIndex, playerAction = _a.playerAction, itemKeys = _a.itemKeys;
        _.omit(item, itemKeys);
        return (React.createElement("div", { key: index, onClick: this.toggleInfo },
            React.createElement(ui_1.DataGridRow, { className: selfTheme.row, index: index, columnsWidth: columnsWidth, key: index, freezeColumnIndex: freezeColumnIndex },
                React.createElement(ui_1.DataGridColumn, null,
                    React.createElement("strong", null, moment(item.date).format("YYYY-MM-DD HH:mm:ss"))),
                itemKeys.map(function (key) {
                    switch (key) {
                        case "date":
                            return;
                        case "actions":
                            return React.createElement(ui_1.DataGridColumn, null,
                                React.createElement(ui_1.LinkButton, { onClick: _this.onAdServerTester, iconName: "icon-supervisor", iconSize: 2, disabled: !playerAction }));
                        case "url":
                            return React.createElement(ui_1.DataGridColumn, null, item[key] ?
                                React.createElement("div", { style: { display: "flex", gap: "1rem" } },
                                    React.createElement(ui_1.LinkButton, { iconName: "icon-copy", iconSize: 2, gray: true, onClick: _this.onUrlCopyClick }),
                                    React.createElement("a", { onClick: function (e) { return e.stopPropagation(); }, href: item[key], target: "_blank" }, item[key]))
                                : "No Data");
                        case "curl":
                            return React.createElement(ui_1.DataGridColumn, { style: { display: "flex", alignItems: "center", justifyContent: "center" } },
                                React.createElement(ui_1.LinkButton, { iconName: "icon-copy", iconSize: 2, blue: true, onClick: _this.onCurlCopyClick }));
                        default:
                            return React.createElement(ui_1.DataGridColumn, null, item[key] ? item[key] : "No Data");
                    }
                }))));
    };
    return Row;
}(React.Component));
exports.default = Row;
